import { Text } from '../components/typography';
import { dateOptions, inputTypes } from './inspection';
import { Form } from 'react-bootstrap';
import MultiSelect from '../components/forms/MultiSelect';
import moment from 'moment';
import DefaultDateSelector from '../components/DefaultDateSelector';

export function questionTypes({
  title,
  description,
  inputType,
  required,
  additionalData,
  id,
  onChange = () => {},
  questions = [],
}) {
  const dateFormat = dateOptions[inputType];
  const current = questions?.find((q) => q.id === id)?.value;
  const input = () => {
    switch (inputType) {
      case inputTypes.textMulti:
        return (
          <Form.Control
            key={id}
            value={current}
            as={'textarea'}
            onChange={(e) => onChange(e.target.value)}
          />
        );
      case inputTypes.select:
        return (
          <div>
            {additionalData?.split('|').map((a) => (
              <Form.Check
                key={a}
                type="radio"
                label={a}
                inline
                name={`singleselect-${id}`}
                value={a}
                onChange={(e) => {
                  onChange(e.target.value);
                }}
              />
            ))}
          </div>
        );
      case inputTypes.multiSelect:
        const values = questions?.find((q) => q.id === id)?.value;
        return (
          <MultiSelect
            key={id}
            title={' '}
            inline
            name={`multiselect-${id}`}
            values={values || []}
            options={additionalData?.split('|') || []}
            onChange={(newValue) => onChange(newValue)}
          />
        );
      case inputTypes.time:
      case inputTypes.date:
      case inputTypes.dateTime:
        const type = () => {
          switch (inputType) {
            case inputTypes.time:
              return 'time';
            case inputTypes.dateTime:
              return 'datetime-local';
            default:
              return 'date';
          }
        };
        return (
          <div key={id}>
            <DefaultDateSelector
              type={type()}
              placeholder="Select Date"
              id={`datetime-${id}`}
              name={`datetime-${id}`}
              value={current || ''}
              onChange={(e) => {
                let value = e.target.value;
                if (inputType !== inputTypes.time)
                  value = moment(e.target.value).format(dateFormat.format);
                onChange(value);
              }}
            />
          </div>
        );
      default:
        return (
          <Form.Control
            value={current || ''}
            key={id}
            onChange={(e) => onChange(e.target.value)}
          />
        );
    }
  };
  return (
    <div key={id}>
      <div>
        <Text noMargin weight="semiBold" size="md">
          {title} <span style={{ color: 'red' }}>{required ? '*' : ''}</span>
        </Text>
        <Text noMargin size="sm" color="secondary">
          {description}
        </Text>
      </div>
      {input()}
    </div>
  );
}
